import React from "react";
/**
 * Render a container wrapping the month grids.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Months(props) {
    return React.createElement("div", { ...props });
}
//# sourceMappingURL=Months.js.map